var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('v-card-title',[_vm._v(" Project Timeline ")]),_c('v-img',{attrs:{"src":require("../../../public/static/About/Timeline_updated_12022020.png")}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }